import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M13.681 3.75v6.353h6.421v3.488h-6.421v6.659l-9.784-8.267 9.784-8.233z"
}), 'LongArrowLeft');